import SearchJSX from '../../../@WUM/core/component/const/SearchJSX'
import { ContentSwitch, IntlMessage, IntlMessageValue } from '../../../@WUM/core/Elements/index'
import { removeUseLocalStorage } from '../../../@WUM/core/component/const/useLocalStoreage'
import { SpinnerJSX } from '../../../@WUM/core/component/const/Spinner'
const DynamikComponents = {
    SearchJSX: SearchJSX,
    ContentSwitch: ContentSwitch,
    IntlMessage: IntlMessage,
    IntlMessageValue: IntlMessageValue,
    removeUseLocalStorage: removeUseLocalStorage,
    SpinnerJSX: SpinnerJSX
}

export default DynamikComponents
